import {useEffect} from 'react';
import useInView from "./utils/useInView";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {useEmployees, useGetEmployees} from "./stores/otherStore";
import {useNavigate} from "react-router-dom";

const Employees = () => {
    const [ref, inView] = useInView();
    const getEmployees = useGetEmployees();
    const employees = useEmployees();
    const navigate = useNavigate();

    useEffect(() => {
        void getEmployees();
    }, [getEmployees]);

    const staticSpecialists = employees.filter(s => s.ranking === 1).slice(0, 2);
    const sliderSpecialists = employees.filter(s => s.ranking !== 1);

    const settings = {
        dots: true,
        infinite: sliderSpecialists.length > 2,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    arrows: false
                }
            }
        ]
    };

    return (
        <div
            ref={ref}
            className={`opacity-0 scale-90 transition-all duration-500
        ${inView ? "animate-fadeIn" : ""}`}
        >
            <div className="container flex flex-col items-center py-16 px-4 sm:px-6 lg:px-10">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-8 text-center">
                    Наши сотрудники
                </h2>

                {/* Два статичных специалиста */}
                <div className="flex flex-col sm:flex-row justify-between w-full gap-6">
                    {staticSpecialists.map((ser, idx) => (
                        <button
                            className="flex flex-col sm:flex-row justify-center items-center sm:w-1/2 gap-6 sm:gap-10 my-8 sm:my-16"
                            key={idx}
                            onClick={() => navigate(`/detail/about/${ser.id}`)}
                        >
                            <div
                                className="rounded-full mb-4 sm:mb-8 w-32 h-32 sm:size-40 bg-cover bg-center"
                                style={{backgroundImage: `url(${ser.photo})`}}
                            />
                            <div className="text-center sm:text-left w-40 font-semibold">
                                <h4 className="text-lg sm:text-2xl">
                                    {ser.first_name} {ser.last_name}
                                </h4>
                                <h5 className="text-xl sm:text-xl text-[#000] mb-3 font-normal">
                                    {ser.position}
                                </h5>
                            </div>
                        </button>
                    ))}
                </div>

                {/* Слайдер для остальных */}
                {sliderSpecialists.length > 0 && (
                    <Slider {...settings} className="w-full">
                        {sliderSpecialists.map((ser, index) => (
                            <div key={index} className="!flex flex-wrap justify-center">
                                <div
                                    className="flex flex-col sm:flex-row justify-center items-center gap-6 sm:gap-10 my-8 sm:my-16 cursor-pointer"
                                    onClick={() => navigate(`/detail/about/${ser.id}`)}
                                >
                                    <div
                                        className="rounded-full mb-4 sm:mb-8 w-32 h-32 sm:size-40 bg-cover bg-center"
                                        style={{backgroundImage: `url(${ser.photo})`}}
                                    />
                                    <div className="text-center sm:text-left w-40">
                                        <h4 className="font-semibold text-lg sm:text-2xl">
                                            {ser.first_name} {ser.last_name}
                                        </h4>
                                        <h5 className=" text-xl sm:text-xl text-[#000] mb-3">
                                            {ser.position}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                )}
            </div>
        </div>
    );
};

export default Employees;
